import styled from 'styled-components';
import { theme } from '../../../theme/GlobalTheme';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  margin: 0;
  padding: ${theme.spacing.xl} 0 0 0;
  width: 100%;
  min-height: 500px;
`;

export const Wrapper = styled.div`
  background-color: rgba(0, 33, 105, 0.9);
  border-radius: ${theme.borderRadius.xlarge};
  padding: ${theme.spacing.xl};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1000px;
  width: 90%;
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  margin: ${theme.spacing.xl} auto;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.lg};
    width: 95%;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${theme.colors.white};
  margin: 0 0 ${theme.spacing.md} 0;
  font-size: ${theme.typography.fontSize.h1};
  font-weight: ${theme.typography.fontWeight.bold};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.h2`
  color: ${theme.colors.white};
  margin: 0 0 ${theme.spacing.xl} 0;
  font-size: 24px;
  font-weight: ${theme.typography.fontWeight.normal};
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.4;
  max-width: 800px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 20px;
  }
`;

export const Description = styled.p`
  color: ${theme.colors.white};
  margin: 0 0 ${theme.spacing.lg} 0;
  font-size: ${theme.typography.fontSize.body};
  line-height: 1.6;
  max-width: 100%;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  
  &:last-of-type {
    margin-bottom: ${theme.spacing.xl};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

export const ActionButton = styled.button`
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  border: none;
  border-radius: ${theme.borderRadius.medium};
  font-size: 18px;
  font-weight: ${theme.typography.fontWeight.bold};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: ${theme.shadows.light};
  min-width: 200px;

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }

  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 16px;
    padding: ${theme.spacing.md} ${theme.spacing.lg};
  }
`;
